import * as Yup from 'yup'
import { VALIDATION_KEYS } from './../../utils/translation-constants';
import validationConfig from "custom/config/validation.config.json";
const forgotPasswordConfig = validationConfig["forgotPassword"];
const loginConfig = validationConfig["login"];
const resetPasswordConfig = validationConfig["resetPassword"];

const validateUserName = loginConfig["isUserNameRequired"]
  ? {
    username: Yup.string()
    .min(4, VALIDATION_KEYS.USERNAME_MIN_MAX_LENGTH)
    .max(40, VALIDATION_KEYS.USERNAME_MIN_MAX_LENGTH)
    .required(VALIDATION_KEYS.USERNAME_REQUIRED)
    }
  : {
      username: Yup.string().optional(),
    };

const validatePassword = loginConfig["isPasswordRequired"]
  ? {
    password: Yup.string().required(VALIDATION_KEYS.PASSWORD_REQUIRED),
    }
  : {
      password: Yup.string().optional(),
    };

const validateCode = loginConfig["verifyCodeRequired"]
  ? {
    otp: Yup.string().required(VALIDATION_KEYS.VERIFY_CODE),
    }
  : {
      otp: Yup.string().optional(),
    };
const validateForgotUsername = forgotPasswordConfig["isUserNameRequired"]
  ? {
    userName: Yup.string()
    .matches(new RegExp('^[a-zA-Z0-9]{3,}$'), VALIDATION_KEYS.ALPHA_NUMERIC)
    .min(4, VALIDATION_KEYS.USERNAME_MIN_MAX_LENGTH)
    .max(40, VALIDATION_KEYS.USERNAME_MIN_MAX_LENGTH)
    .required(VALIDATION_KEYS.USERNAME_REQUIRED),
    }
  : {
    userName: Yup.string().optional()
    .matches(new RegExp('^[a-zA-Z0-9]{3,}$'), VALIDATION_KEYS.ALPHA_NUMERIC)
    .min(4, VALIDATION_KEYS.USERNAME_MIN_MAX_LENGTH)
    .max(40, VALIDATION_KEYS.USERNAME_MIN_MAX_LENGTH)
    };
const validateForgotDOB = forgotPasswordConfig["isDOBRequired"]
  ? {
    dob: Yup.date().required(VALIDATION_KEYS.DOB_REQUIRD),
    }
  : {
      dob: Yup.date().optional(),
    };

const validateForgotPhoneNo = forgotPasswordConfig["isPhoneNoRequired"]
  ? {
    phoneNo: Yup.string().required(VALIDATION_KEYS.MOBILE_NO_REQUIRED),
    }
  : {
      phoneNo: Yup.string().optional(),
    };

const validateNewPassword = forgotPasswordConfig["isNewPasswordRequired"]
  ? {
    newPassword: Yup.string()
    .required(VALIDATION_KEYS.NEW_PASSWORD_REQUIRED)
    .min(8, VALIDATION_KEYS.NEW_PASSWORD_MIN_LENGTH)
    .max(13, VALIDATION_KEYS.NEW_PASSWORD_MAX_LENGTH),
    }
  : {
    newPassword: Yup.string()
    .optional()
    .min(8, VALIDATION_KEYS.NEW_PASSWORD_MIN_LENGTH)
    .max(13, VALIDATION_KEYS.NEW_PASSWORD_MAX_LENGTH),
    };

const validateConfirmNewPassword = forgotPasswordConfig[
  "isConfirmPasswordRequired"
]
  ? {
    confirmNewPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], VALIDATION_KEYS.PASSWORD_MATCH)
    .required(VALIDATION_KEYS.CONFIRM_PASSWORD_REQUIRED),
    }
  : {
    confirmNewPassword: Yup.string().optional()
    .oneOf([Yup.ref('newPassword'), null], VALIDATION_KEYS.PASSWORD_MATCH)
    };

const validateCapcha = forgotPasswordConfig["isCapchaRequired"]
  ? {
    captchaCode: Yup.string().required(VALIDATION_KEYS.CAPCHA),
    }
  : {
      captchaCode: Yup.string().optional(),
    };

const validateOtp = forgotPasswordConfig["isOTPRequired"]
  ? {
    otp: Yup.string().matches(new RegExp('^[0-9]{4}$'), VALIDATION_KEYS.VALIDATE_OTP).required(VALIDATION_KEYS.OTP_REQUIRED),
    }
  : {
    otp: Yup.string().optional().matches(new RegExp('^[0-9]{4}$'), VALIDATION_KEYS.VALIDATE_OTP)
    };

const validateResetNewPassword = resetPasswordConfig["isNewPasswordRequired"]
  ? {
    newPassword: Yup.string()
    .required(VALIDATION_KEYS.NEW_PASSWORD_REQUIRED)
    .min(8, VALIDATION_KEYS.NEW_PASSWORD_MIN_LENGTH)
    .max(13, VALIDATION_KEYS.NEW_PASSWORD_MAX_LENGTH),
    }
  : {
      newPassword: Yup.string().optional(),
    };
const validateResetConfirmNewPassword = resetPasswordConfig[
  "isConfirmNewPasswordRequired"
]
  ? {
    confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], VALIDATION_KEYS.CONFIRM_NEW_PASSWORD)
    .required(VALIDATION_KEYS.CONFIRM_PASSWORD_REQUIRED),
    }
  : {
      confirmPassword: Yup.string().optional(),
    };

export const LoginSchema = Yup.object().shape({
  ...validateUserName,
  ...validatePassword,
});

export const VerifySchema = Yup.object().shape({
  ...validateCode,
});

export const ForgotPasswordSchema = Yup.object().shape({
  ...validateForgotUsername,
  ...validateForgotDOB,
  ...validateForgotPhoneNo,
});

export const ForgotPasswordConfirmSchema = Yup.object().shape({
  ...validateNewPassword,
  ...validateConfirmNewPassword,
  ...validateCapcha,
  ...validateOtp,
});

export const resetPasswordSchema = Yup.object().shape({
  ...validateResetNewPassword,
  ...validateResetConfirmNewPassword,
});
